export default __webpack_public_path__ + "static/media/image-about-mission-m@3x.bc8d3e91.webp";